import { Card, Typography, Stack } from "@mui/material";
import { Box } from "@mui/system";
import {
  colors,
  spacing,
  typography,
} from "../../../../../../../../../../assets/styles/tokens";

// ─────────────────────────────────────────────────────────────────────────────

interface ProblematicFtdsProps {
  website_name: string;
  website_id: string;
  ftd: string;
  brand_action_date: string;
}

export function ProblematicFtdsCard({
  website_name,
  website_id,
  ftd,
  brand_action_date,
}: ProblematicFtdsProps) {
  return (
    <>
      <Card
        sx={{
          p: 1,
          borderRadius: spacing.Radius.lg.$value,
          boxShadow: "0px 1px 2px #0A0D120F , 0px 1px 3px #0A0D121A",
          border: "1px solid" + colors.GrayLightMode[200].$value,
          mb: spacing.Spacing.none.$value,
          mt: spacing.Spacing.xl.$value + "!important",
        }}
      >
        {/* Top Row */}
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography
            variant="body1"
            sx={{
              color: colors.GrayLightMode[700].$value,
              fontSize: typography.Size.Text.xs.$value,
              fontWeight: typography.Font_weight.Medium.$value,
            }}
          >
            {website_name} ({website_id})
          </Typography>
        </Stack>

        <Stack sx={{ mb: spacing.Spacing.xs.$value }}>
          <Typography
            variant="body1"
            sx={{
              fontSize: typography.Size.Text.sm.$value,
              color: colors.GrayLightMode[900].$value,
            }}
          >
            Players Total FTD:
            <Box
              component="span"
              sx={{
                fontSize: typography.Size.Text.xl.$value,
                fontWeight: typography.Font_weight.Medium.$value,
                ml: spacing.Spacing.xs.$value,
              }}
            >
              {ftd}
            </Box>
          </Typography>
        </Stack>
        <Stack>
          <Typography
            variant="body1"
            sx={{
              fontSize: typography.Size.Text.sm.$value,
              color: colors.GrayLightMode[900].$value,
            }}
          >
            Brand Action Date:
            <Box
              component="span"
              sx={{
                fontSize: typography.Size.Text.sm.$value,
                fontWeight: typography.Font_weight.Medium.$value,
                ml: spacing.Spacing.xs.$value,
              }}
            >
              {brand_action_date}
            </Box>
          </Typography>
        </Stack>
      </Card>
    </>
  );
}
export default ProblematicFtdsCard;
